import React, { useState } from "react";
import {
    Box,
    Typography,
    Modal,
    Avatar,
    Grid,
    Link,
    IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import LinkedInIcon from "@mui/icons-material/LinkedIn";


const leaders = [
    {
        name: "Nick Lagrotta",
        title: "Senior Vice President of Information Technology",
      
        linkedIn: "https://www.linkedin.com/in/nick-lagrotta-983a10/",
        image: "/NickL.png",
    },
    {
        name: "Nicole Rogers",
        title: "Director of Customer Success",
       
        linkedIn: "https://www.linkedin.com/in/nicole-rogers-209758318/",
        image: "/Nicole.png",
    }
];


const HoverImage = styled("img")(({ theme }) => ({
    width: 200,
    height: 200,
    borderRadius: "50%",
    objectFit: "cover",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
        transform: "scale(1.1)",
        boxShadow: theme.shadows[6],
        cursor: "pointer",
    },
}));

const ModalContent = styled(Box)(({ theme }) => ({
    backgroundColor: "#fff",
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(3),
    borderRadius: "16px",
    width: "70%",
    maxWidth: "800px",
    margin: "auto",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        width: "90%",
    },
}));

export default function LeadershipPage() {
    const [open, setOpen] = useState(false);
    const [selectedLeader, setSelectedLeader] = useState(null);

    const handleOpen = (leader) => {
        setSelectedLeader(leader);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedLeader(null);
    };

    return (
        <Box sx={{ textAlign: "center", p: 5 }}>
            <Typography variant="h4" fontWeight="bold" mb={4}>
                Leadership Team
            </Typography>

            {/* Team Grid */}
            <Grid container spacing={4} justifyContent="center">
                {leaders.map((leader, index) => (
                    <Grid
                        item
                        key={index}
                        sx={{
                            textAlign: "center",
                        }}
                    >
                        <Box sx={{ cursor: "pointer" }}>
                            <HoverImage
                                src={leader.image}
                                alt={leader.name}
                                onClick={() => handleOpen(leader)}
                            />
                            <Typography variant="h6" style={{fontWeight:'bold'}} mt={2}>
                                {leader.name}
                            </Typography>
                            <Typography variant="subtitle2" color="text.secondary">
                                {leader.title}
                            </Typography>

                            {/* LinkedIn icon in grid */}
                            <Box mt={1}>
                                <Link
                                    href={leader.linkedIn} 
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    underline="none"
                                >
                                    <LinkedInIcon
                                        sx={{
                                            fontSize: 28,
                                            color: "#0A66C2",
                                            "&:hover": { color: "#004182" },
                                        }}
                                    />
                                </Link>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>

            {/* Modal */}
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.6)" } }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                        p: 2,
                    }}
                >
                    {selectedLeader && (
                        <ModalContent
                            sx={{
                                boxShadow: 6,
                                bgcolor: "#fff",
                                p: 4,
                                borderRadius: 3,
                                position: "relative",
                                maxWidth: 700,
                                width: "100%",
                                transition: "all 0.3s ease",
                            }}
                        >
                            {/* Close Button */}
                            <IconButton
                                onClick={handleClose}
                                sx={{
                                    position: "absolute",
                                    top: 12,
                                    right: 12,
                                    color: "gray",
                                    "&:hover": { color: "black" },
                                }}
                            >
                                <CloseIcon fontSize="medium" />
                            </IconButton>

                            {/* Content Wrapper */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", sm: "row" },
                                    gap: 4,
                                    alignItems: { xs: "center", sm: "flex-start" },
                                }}
                            >
                                {/* Image */}
                                <Avatar
                                    src={selectedLeader.image}
                                    alt={selectedLeader.name}
                                    sx={{
                                        width: { xs: 150, sm: 200 },
                                        height: { xs: 150, sm: 200 },
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        flexShrink: 0,
                                        boxShadow: 3,
                                    }}
                                />

                                {/* Text Content */}
                                <Box sx={{ textAlign: { xs: "center", sm: "left" }, flex: 1 }}>
                                    <Typography variant="h5" fontWeight="bold" mb={1}>
                                        {selectedLeader.name}
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        color="text.secondary"
                                        mb={2}
                                        fontStyle="italic"
                                    >
                                        {selectedLeader.title}
                                    </Typography>
                                     {/* LinkedIn Icon */}
                                    <Link
                                        href={selectedLeader.linkedIn}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        underline="none"
                                    >
                                        <LinkedInIcon
                                            sx={{
                                                fontSize: 36,
                                                color: "#0A66C2",
                                                "&:hover": { color: "#004182", transform: "scale(1.1)" },
                                                transition: "all 0.2s ease",
                                            }}
                                        />
                                    </Link>

                                    <Typography variant="body1" mb={2} sx={{ lineHeight: 1.6 }}>
                                        {selectedLeader.bio}
                                    </Typography>

                                   
                                </Box>
                            </Box>
                        </ModalContent>
                    )}
                </Box>
            </Modal>

        </Box>
    );
}
